// extracted by mini-css-extract-plugin
export default {"text":"DeleteConfirmationModal_text__zhWmi","btnArea":"DeleteConfirmationModal_btnArea__1p9MN"};